import { workSheetStatusInversed } from '@teinor/erp/types/company/order/sell/workSheet'
import TitleAndWhiteBoxLayout from '../../../../../../../../../baseComponents/Layout/TitleAndWhiteBoxLayout'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import { InputTableLayoutData } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { SingleWorkSheetProductStatusFlow } from '../../../../../../../../../specificComponents/inputTableLayouts/order/WorkSheetLayout/WorkSheetProductStatusFlow'
import useWorkSheetProductStatusUrls from '../../../../../../../../../utils/hooks/sells/orders/useWorkSheetProductStatusUrls'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { getAllWorkSheetGroupStatuses, getUserPermissions } from '../../../../../../../../../utils/reducers/getters'
import { WorkSheetChangeStatusView } from '../../WorkSheetButtons'
import LoadingSpinner from '../../../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'

interface WorkSheetProductStatusViewProps {
    handleChangeView: () => void
    completeData: InputTableLayoutData | null
    WorkSheetId: number
}

const WorkSheetProductStatusView: React.FC<WorkSheetProductStatusViewProps> = ({ handleChangeView, completeData, WorkSheetId }) => {
    const { t, tVars } = useTwinTranslation()
    const workSheetProductStatusURLs = useWorkSheetProductStatusUrls()
    const workSheetProductStatuses = getAllWorkSheetGroupStatuses()
    if (!completeData) {
        return <LoadingSpinner/>
    }
    const myWorkSheetStatus = workSheetProductStatuses?.dictWorkSheetGroupStatus?.[completeData?.header?.WorkSheetGroupStatusId]?.WorkSheetProductStatusesDict || {}
    const options = { fullAssignedNumber: completeData?.header?.custom_name || completeData?.header?.full_assigned_number, CustomerName: completeData?.header?.Customer?.fiscal_name || completeData?.header?.Customer?.name }
    const title = tVars('singleWorkSheetWithCustomer', 'Hoja de trabajo {{fullAssignedNumber}} - {{CustomerName}}', options)
    return (
        <TitleAndWhiteBoxLayout title={title} className='small_paddings_whitebox' RightHeader={
            <div className='flex gap-10 justify-between flex-wrap items-center flex-auto ml-auto'>
                <WorkSheetChangeStatusView title={t('changeView', 'Cambiar vista')} handleChangeView={handleChangeView} WorkSheetId={WorkSheetId} workSheetProductStatuses={myWorkSheetStatus}/>
            </div>}>
            <SingleWorkSheetProductStatusFlow WorkSheetId={completeData?.header?.id} workSheetProductStatusURLs={workSheetProductStatusURLs} workSheetProductStatuses={workSheetProductStatuses} readOnly={(permissionCheck(getUserPermissions('sell.workSheetProductStatus'), 'update') ? false : true) || parseInt(completeData?.header?.status) === workSheetStatusInversed['finished']} WorkSheetGroupStatusId={completeData?.header?.WorkSheetGroupStatusId} />
        </TitleAndWhiteBoxLayout>
    )
}

export default WorkSheetProductStatusView
